<template>
  <div class="blocked_logs_page">
    <h1>首充用户留存/复购表</h1>
    <div class="user-options ">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="language" placeholder>
        <el-option
          v-for="(item, itemIndex) in languageList"
          v-bind:key="itemIndex + 199"
          :label="item.language"
          :value="item.langCode"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="country" placeholder>
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <el-select
        style="width: 240px"
        v-model="goods"
        multiple
        collapse-tags
        placeholder
        @change="channelChange"
      >
        <el-option
          v-for="(item, itemIndex) in goodss"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="searchType" placeholder>
        <el-option
          v-for="(item, itemIndex) in searchTypes"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="user-options ">
      <el-select style="width: 160px" v-model="userType" placeholder>
        <el-option
          v-for="(item, itemIndex) in userTypes"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select style="width: 160px" v-model="platform" placeholder>
        <el-option
          v-for="(item, itemIndex) in platforms"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="platformData"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="retainedOptions"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-button type="primary" @click="get_list">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>

    <div class="user-options ">
      <el-table :data="tableList" border v-loading="login1">
        <el-table-column align="center" prop="date" label="日期" sortable>
        </el-table-column>
        <el-table-column
          align="center"
          prop="day1"
          label="第1日(首充人数)"
          sortable
        >
        </el-table-column>
        <el-table-column
          v-if="!day"
          align="center"
          prop="day1Recharge2"
          label="当日复购"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day2"
          :label="day ? '第2日留存' : '第2日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day3"
          :label="day ? '第3日留存' : '第3日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day4"
          :label="day ? '第4日留存' : '第4日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day5"
          :label="day ? '第5日留存' : '第5日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day6"
          :label="day ? '第6日留存' : '第6日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day7"
          :label="day ? '第7日留存' : '第7日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day8"
          :label="day ? '第8日留存' : '第8日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day9"
          :label="day ? '第9日留存' : '第9日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day10"
          :label="day ? '第10日留存' : '第10日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day11"
          :label="day ? '第11日留存' : '第11日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day12"
          :label="day ? '第12日留存' : '第12日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day13"
          :label="day ? '第13日留存' : '第13日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day14"
          :label="day ? '第14日留存' : '第14日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day15"
          :label="day ? '第15日留存' : '第15日复购'"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="day30"
          :label="day ? '第30日留存' : '第30日复购'"
          sortable
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="50"
        class="pagination"
      ></el-pagination>
     </el-row> -->
  </div>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data () {
    return {
      login1: false,
      login2: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      page: 1,
      total: 0,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: 0,
      userTypes: [
        {
          label: 'total',
          value: 0
        },
        {
          label: ' 新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        }
      ],
      platform: 0,
      platforms: [
        {
          label: 'total',
          value: 0
        },
        {
          label: ' 安卓',
          value: 1
        },
        {
          label: ' ios',
          value: 2
        }
      ],
      searchType: 1,
      searchTypes: [
        {
          label: '留存',
          value: 1
        },
        {
          label: '复购',
          value: 2
        }
      ],
      goods: ['total'],
      goodss: [
        {
          label: 'total',
          value: 'total'
        },
        {
          label: 'money5_4.99',
          value: 'money5'
        },
        {
          label: 'money10_9.99',
          value: 'money10'
        },
        {
          label: 'money10vip1m_9.99',
          value: 'money10vip1m'
        },
        {
          label: 'money1_0.99',
          value: 'money1'
        },
        {
          label: 'money12_11.99',
          value: 'money12'
        },
        {
          label: 'money5web_4.99',
          value: 'money5web'
        },
        {
          label: 'money10web_9.99',
          value: 'money10web'
        },
        {
          label: 'money20web_19.99',
          value: 'money20web'
        },
        {
          label: 'money50web_49.99',
          value: 'money50web'
        },
        {
          label: 'money100web_99.99',
          value: 'money100web'
        },
        {
          label: 'money8_7.99',
          value: 'money8'
        },
        {
          label: 'money200_199.99',
          value: 'money200'
        },
        {
          label: 'money3vip1w_2.99',
          value: 'money3vip1w'
        },
        {
          label: 'money25vip3m_24.99',
          value: 'money25vip3m'
        },
        {
          label: 'money8pay_7.99',
          value: 'money8pay'
        },
        {
          label: 'money12pay_11.99',
          value: 'money12pay'
        },
        {
          label: 'money12pay_11.99',
          value: 'money12pay'
        },
        {
          label: 'money20pay_19.99',
          value: 'money20pay'
        },
        {
          label: 'money50pay_49.99',
          value: 'money50pay'
        },
        {
          label: 'money100pay_99.99',
          value: 'money100pay'
        },
        {
          label: 'money2_1.99',
          value: 'money2'
        },
        {
          label: 'money1web_0.99',
          value: 'money1web'
        }
      ],
      day: false
    }
  },
  beforeCreate () {},
  created () {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted () {},
  computed: {
    username () {
      return this.$store.getters.username
    },
    userLevel () {
      return this.$store.getters.userLevel
    },
    token () {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    channelChange(currentVal) {
      const currentValLen = currentVal.length
      if (currentValLen !== 1) {
        if (
          currentVal[currentValLen - 1] === 'total' ||
          currentVal[currentValLen - 1] === 'all'
        ) {
          this.goods = [currentVal[currentValLen - 1]]
        }
      }

      if (currentValLen === 2) {
        if (currentVal[0] === 'total' || currentVal[0] === 'all') {
          this.goods = [currentVal[currentValLen - 1]]
        }
      }
    },
    async languages () {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_ () {
      this.login1 = true
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },

    // 分页
    handleCurrentChange () {
      this.get_list()
    },
    async get_list () {
      this.login1 = true
      let data = {
        start: this.platformData[0],
        end: this.platformData[1],
        channel: this.curChannel.selectValue,
        country: this.country,
        language: this.language,
        searchType: this.searchType,
        goods: this.goods,
        userType: this.userType,
        platform: this.platform
      }
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.reports_firstRecharge+'?username=' + this.$store.getters.username + '&token=' + this.$store.getters.token,
        data
      )
      if (res !== null) {
        this.day = false
        if (this.searchType == 1) {
          this.day = true
        }
        this.tableList = res.data.data
        this.total = res.data.total
        this.login1 = false
      }
    },
    // 下载覆盖
    async dwnDayChatDetai () {
      this.login2 = true
      const res = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.reports_firstRecharge_download+'?username=' + this.$store.getters.username + '&token=' + this.$store.getters.token,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          searchType: this.searchType,
          goods: this.goods,
          userType: this.userType,
          platform: this.platform
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      let name = '首充用户留存表'
      if (this.searchType == 2) {
        name = '首充用户复购表'
      }
      download(
        res.data,
        name + (this.platformData[0] + '-' + this.platformData[1])
      )
    }
  }
}
</script>

<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 20px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
